import React from 'react';

interface ProgressModalProps {
  isComplete: boolean;
  error?: string;
  onClose: () => void;
}

export const ProgressModal: React.FC<ProgressModalProps> = ({ error, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Backdrop with blur */}
      <div className="absolute inset-0 bg-black/30 backdrop-blur-sm transition-opacity" />

      {/* Modal Content */}
      <div className="relative bg-white rounded-2xl shadow-xl p-6 md:p-8 max-w-sm w-full mx-4 transform transition-all animate-in fade-in zoom-in duration-200">
        {!error ? (
          <div className="flex flex-col items-center justify-center py-2 md:py-4">
            {/* Modern Spinner */}
            <div className="relative w-14 h-14 md:w-16 md:h-16 mb-4 md:mb-6">
              <div className="absolute top-0 left-0 w-full h-full border-4 border-blue-100 rounded-full"></div>
              <div className="absolute top-0 left-0 w-full h-full border-4 border-blue-600 rounded-full border-t-transparent animate-spin"></div>
            </div>
            
            <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-2 text-center">
              Setting up your account
            </h2>
            <p className="text-gray-500 text-center text-sm">
              Please wait a moment...
            </p>
          </div>
        ) : (
          <div className="text-center">
            {/* Error Icon */}
            <div className="mx-auto mb-3 md:mb-4 w-12 h-12 md:w-14 md:h-14 bg-red-50 rounded-full flex items-center justify-center">
              <svg
                className="w-7 h-7 md:w-8 md:h-8 text-red-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
            
            <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-2">
              Setup failed
            </h2>
            <p className="text-gray-500 mb-5 md:mb-6 text-sm">
              {error}
            </p>
            
            <button
              onClick={onClose}
              className="w-full bg-gray-900 text-white py-2.5 px-4 rounded-xl font-medium hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-all text-sm"
            >
              Try Again
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
